import { en } from "./translations/en";

export type Language = "en" | "yo" | "ha" | "ig";

export type TranslationKeys = typeof en;

export { en };

export const languageNames: Record<Language, string> = {
  en: "English",
  yo: "Yorùbá",
  ha: "Hausa",
  ig: "Igbo",
};

export const languageNativeNames: Record<Language, string> = languageNames;

const cache: Partial<Record<Language, TranslationKeys>> = { en };

/** Loads a language on demand so only the visitor's language is downloaded. */
export async function loadTranslation(lang: Language): Promise<TranslationKeys> {
  const cached = cache[lang];
  if (cached) return cached;
  let result: TranslationKeys;
  switch (lang) {
    case "yo": result = (await import("./translations/yo")).yo; break;
    case "ha": result = (await import("./translations/ha")).ha; break;
    case "ig": result = (await import("./translations/ig")).ig; break;
    default: result = en;
  }
  cache[lang] = result;
  return result;
}

export function getCachedTranslation(lang: Language): TranslationKeys {
  return cache[lang] ?? en;
}
